var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollPosition>_vm.fromTop),expression:"scrollPosition>fromTop"}],staticClass:"btn rounded-circle btn-go-top text-22",on:{"click":function($event){return _vm.goTop()}}},[_c('font-awesome-icon',{staticClass:"rotate-180",attrs:{"icon":"chevron-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }